<!--
  This file is part of vospace-ui
  Copyright (C) 2021 Istituto Nazionale di Astrofisica
  SPDX-License-Identifier: GPL-3.0-or-later
-->
<template>
<div>
  <b-navbar toggleable="lg" type="dark" id="top-menu">
    <b-navbar-brand href="#/" class="d-none d-md-block">VOSpace<sup><b>v1.0</b></sup></b-navbar-brand>
    <JobsMenuItem />
    <b-navbar-nav class="ml-auto">
      <!--<b-nav-item right v-b-modal.modal-faq href="#">FAQ</b-nav-item>-->
      <FAQMenuItem />
      <b-nav-item href="login" class="mr-4" v-if="user === 'anonymous'">Login</b-nav-item>
      <b-nav-item-dropdown :text="user" right v-if="user !== 'anonymous'">
        <b-dropdown-item href="vospace-logout">Logout</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</div>
</template>

<script>
import JobsMenuItem from './JobsMenuItem.vue';
import FAQMenuItem from './FAQMenuItem.vue';

export default {
  components: {
    JobsMenuItem,
    FAQMenuItem
  },
  computed: {
    user() { return this.$store.state.user }
  }
}
</script>

<style>
#top-menu {
  background-color: #093784;
  margin-bottom: 20px;
}

sup {
  color: yellow;
  margin-left: 2px;
}
</style>
